import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q9: '{q8} anyof [0]',
    q24: '{q23} = 0 or {q23} = 1 or {q23} = 2 or {q23} = 3 or {q23} = 4 or {q23} = 5 or {q23} = 6 or {q23} = 7',
    q31: '{q30} = 0',
    q32: '{q30} = 0',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = 1) or ({q3} = 0 or {q3} = 1 or {q3} = 2 or {q3} = 3 or {q3} = 4 or {q3} = 5 or {q3} = 6 or {q3} = 7 or {q3} = 8 or {q3} = 9 or {q3} = 10 or {q3} = 11 or {q3} = 12 or {q3} = 13 or {q3} = 14 or {q3} = 15 or {q3} = 16 or {q3} = 17 or {q3} = 18 or {q3} = 19 or {q3} = 20 or {q3} = 21 or {q3} = 22 or {q3} = 23 or {q3} = 24 or {q3} = 25 or {q3} = 26 or {q3} = 27 or {q3} = 28 or {q3} = 29 or {q3} = 30 or {q3} = 31 or {q3} = 32 or {q3} = 33 or {q3} = 34 or {q3} = 35 or {q3} = 36 or {q3} = 37 or {q3} = 38 or {q3} = 39 or {q3} = 40 or {q3} = 41)`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (
      survey.getValue('q0') === 1 ||
      survey.getValue('q3') === 0 ||
      survey.getValue('q3') === 1 ||
      survey.getValue('q3') === 2 ||
      survey.getValue('q3') === 3 ||
      survey.getValue('q3') === 4 ||
      survey.getValue('q3') === 5 ||
      survey.getValue('q3') === 6 ||
      survey.getValue('q3') === 7 ||
      survey.getValue('q3') === 8 ||
      survey.getValue('q3') === 9 ||
      survey.getValue('q3') === 10 ||
      survey.getValue('q3') === 11 ||
      survey.getValue('q3') === 12 ||
      survey.getValue('q3') === 13 ||
      survey.getValue('q3') === 14 ||
      survey.getValue('q3') === 15 ||
      survey.getValue('q3') === 16 ||
      survey.getValue('q3') === 17 ||
      survey.getValue('q3') === 18 ||
      survey.getValue('q3') === 19 ||
      survey.getValue('q3') === 20 ||
      survey.getValue('q3') === 21 ||
      survey.getValue('q3') === 22 ||
      survey.getValue('q3') === 23 ||
      survey.getValue('q3') === 24 ||
      survey.getValue('q3') === 25 ||
      survey.getValue('q3') === 26 ||
      survey.getValue('q3') === 27 ||
      survey.getValue('q3') === 28 ||
      survey.getValue('q3') === 29 ||
      survey.getValue('q3') === 30 ||
      survey.getValue('q3') === 31 ||
      survey.getValue('q3') === 32 ||
      survey.getValue('q3') === 33 ||
      survey.getValue('q3') === 34 ||
      survey.getValue('q3') === 35 ||
      survey.getValue('q3') === 36 ||
      survey.getValue('q3') === 37 ||
      survey.getValue('q3') === 38 ||
      survey.getValue('q3') === 39 ||
      survey.getValue('q3') === 40 ||
      survey.getValue('q3') === 41
      // survey.getValue('q5') === 0 ||
      // survey.getValue('q5') === 1 ||
      // survey.getValue('q5') === 2 ||
      // survey.getValue('q5') === 3 ||
      // survey.getValue('q5') === 4 ||
      // survey.getValue('q5') === 5 ||
      // survey.getValue('q5') === 6
    ) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
